import type { FC, ReactNode } from "react";

import styles from "./StoreDetailsCard.module.scss";

type StoreDetailsCardProps = {
  title?: string;
  children: ReactNode;
};

export const StoreDetailsCard: FC<StoreDetailsCardProps> = ({ children, title }) => {
  return (
    <div className={styles.storeDetailsCard}>
      {title && <p className={styles.storeDetailsCardTitle}>{title}</p>}
      {children}
    </div>
  );
};
